import React from 'react';

import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import BrandShow from '@shared/brands/BrandShow';
import { useLoaderData } from 'react-router-dom';

import brandService from '@services/operator/brandService';

const OperatorBrandShow: React.FC = () => {
  const brand = useLoaderData() as React.ComponentProps<typeof BrandShow>['brand'];
  const { merchants } = useOperatorData() as { merchants: Array<{ id: string; name: string }> };

  return (
    <BrandShow
      brand={brand}
      brandService={brandService}
      role="operator"
      merchants={merchants}
      basePath="/brands"
    />
  );
};

export default OperatorBrandShow;
